module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_9016.e4394759.png";